import { useTranslation } from "react-i18next";
import { AlertSpg, GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import { Box, Grid } from "@mui/material";
import React from "react";
import UsersListTable from "./UsersListTable";

const UsersList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group }) => {
  const { t } = useTranslation();

  const showTable = () => {
    if (!(total > 0)) {
      return (
        <AlertSpg mt={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      );
    }
    return (
      <UsersListTable
        records={records}
        total={total}
        onPageOrOrderChange={onPageOrOrderChange}
        blockTable={blockTable}
        group={group}
      />
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default UsersList;
